import { createStore, applyMiddleware } from 'redux'
import promise from 'redux-promise'

import rootReducer from '../reducers'

import { trackGAEvent } from '../components/utilities/tracking'

const analytics = () => next => (action) => {
    if (!action.meta || !action.meta.analytics) {
        return next(action)
    }

    const { eventType, eventPayload } = action.meta.analytics
    trackGAEvent(eventType, eventPayload)

    return next(action)
}

const createStoreWithMiddleware = createStore(
    rootReducer,
    applyMiddleware(
        promise,
        analytics,
    )
)

export default createStoreWithMiddleware



// WEBPACK FOOTER //
// ./src/store/index.js